import { Link } from 'react-router-dom';

import Sort from '@/components/SortOptions';
import BcList from '@/components/home/bcList';
import LocationPermissionUI from '@/components/home/locationPermissionUI';
import RecentlyViewed from '@/components/home/recentlyList';
import SearchInput from '@/components/ui/searchInput';
import useHome from '@/hooks/home/useHome';
import { EVENTS, TrackEvent, useTrackPageView } from '@/services/track';

const Home = () => {
  const {
    searchTerm,
    orderCriteria,
    advertisement,
    bowlingCenters,
    sortOptionsRef,
    showPermissionUi,
    locationPermissionDenied,
    onRequestPermission,
    onSort,
    onSearch,
  } = useHome();

  useTrackPageView();

  return (
    <>
      <section
        className="h-[calc(100vh/5)] overflow-hidden"
        data-cy="top-banner"
      >
        <a
          href="https://youtu.be/lpXkSn-npXQ"
          target="_blank"
          rel="noopener noreferrer"
          onClick={() =>
            TrackEvent(EVENTS.BANNER_CLICK, {
              position: 'top',
            })
          }
        >
          <img
            src="/images/banner.png"
            alt="Lanetalk banner"
            className="w-full h-full object-contain"
          />
        </a>
      </section>

      <section className="pt-16 max-w-[1400px] mx-auto px-4">
        <div className="mb-12 text-center sticky top-24 md:top-[71px] backdrop-blur-md py-4">
          <SearchInput
            className="max-w-[768px] mx-auto"
            onChange={(e) => onSearch(e.target.value)}
            value={searchTerm}
            data-cy="search-input"
          />
        </div>
        <div className="flex flex-col gap-6 md:flex-row md:justify-center md:flex-wrap pb-8">
          <div className="w-full max-w-[768px]">
            <h3 className="text-xl">Bowling Centers</h3>

            <RecentlyViewed />

            <div
              className="sticky top-[171px] md:top-[146px] backdrop-blur-md py-4"
              ref={sortOptionsRef}
            >
              <Sort value={orderCriteria} onChange={onSort} />
            </div>
            {showPermissionUi ? (
              <LocationPermissionUI
                onRequestPermission={onRequestPermission}
                permissionDenied={locationPermissionDenied}
              />
            ) : (
              <BcList {...bowlingCenters} searchTerm={searchTerm} />
            )}
          </div>
          <div className="md:size-[512px] md:sticky md:top-[160px] flex items-start mt-[46px]">
            {advertisement && (
              <Link
                to={advertisement.link_url}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={advertisement.image_url}
                  alt="Lanetalk banner"
                  className="w-full object-contain"
                />
              </Link>
            )}
          </div>
        </div>
      </section>
    </>
  );
};

export default Home;
